import { useIntlShort } from "@moim/common";
import * as React from "react";
import { TitleSection, Title, RightArrow } from "./styled";

const MyDQuests: React.FC = () => {
  const intl = useIntlShort();
  const enableDquest = true;

  if (!enableDquest) {
    return null;
  }

  return (
    <TitleSection onClick={() => {}}>
      <Title>{intl("my_quest")}</Title>
      <RightArrow />
    </TitleSection>
  );
};

export default React.memo(MyDQuests);
